"use client";

import React, { useRef } from "react";
import { ArrowUpRight, ChevronLeft, ChevronRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const leaderCards = [{
  id: "red-multiplicacion",
  title: "RED DE MULTIPLICACIÓN DE IGLESIAS",
  description: "Empoderamos a líderes para crear iglesias saludables en cada comunidad.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/church_multiplication_network.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/church_multiplication_network.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/church_multiplication_network.png-wvc-sizes",
  alt: "Líderes orando y capacitando iglesias",
  link: "#"
}, {
  id: "revista-influence",
  title: "REVISTA INFLUENCE",
  description: "Inspiramos y capacitamos a líderes con recursos prácticos, perspectivas teológicas e historias de liderazgo para que impacten sus comunidades.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/influence_magazine_resource.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/influence_magazine_resource.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/influence_magazine_resource.webp-wvc-sizes",
  alt: "Revista Influence con artículos de liderazgo",
  link: "#"
}, {
  id: "proceso-hechos-2",
  title: "PROCESO HECHOS 2",
  description: "Acompañamos a líderes en un proceso transformador para fortalecer las iglesias de manera espiritual, numérica y relacional.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/acts_2_church_process.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/acts_2_church_process.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/acts_2_church_process.png-wvc-sizes",
  alt: "Grupo de líderes en taller y capacitación",
  link: "#"
}, {
  id: "llamado",
  title: "LLAMADO",
  description: "Empoderamos y capacitamos a quienes están llamados al ministerio vocacional a través del desarrollo del liderazgo, oportunidades de conexión y aliento espiritual.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/calling_vocational_ministry.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/calling_vocational_ministry.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/calling_vocational_ministry.png-wvc-sizes",
  alt: "Mujer líder en ministerio vocacional",
  link: "#"
}];
export default function LeaderResources() {
  const shouldReduceMotion = useReducedMotion();
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -320,
        behavior: "smooth"
      });
    }
  };
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 320,
        behavior: "smooth"
      });
    }
  };
  return <section id="leaderresourcesgrid" data-nav="light" className="relative w-full bg-muted/20 py-12 md:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          {}
          <div className="hidden sm:flex absolute -left-4 top-1/2 -translate-y-1/2 z-20">
            <Button type="button" variant="outline" size="icon" onClick={scrollLeft} className="rounded-full bg-background/90 text-foreground shadow-md hover:bg-background border-border size-10" aria-label="Desplazar a la izquierda">
              <ChevronLeft className="size-5" />
            </Button>
          </div>

          <div className="hidden sm:flex absolute -right-4 top-1/2 -translate-y-1/2 z-20">
            <Button type="button" variant="outline" size="icon" onClick={scrollRight} className="rounded-full bg-background/90 text-foreground shadow-md hover:bg-background border-border size-10" aria-label="Desplazar a la derecha">
              <ChevronRight className="size-5" />
            </Button>
          </div>

          {}
          <div ref={scrollContainerRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-none">
            {leaderCards.map((card, i) => <motion.div key={card.id} data-index={i} initial={shouldReduceMotion ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 24
          }} whileInView={shouldReduceMotion ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: "-40px"
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="group relative flex flex-col justify-end min-h-[440px] md:min-h-[480px] rounded-2xl overflow-hidden shadow-md bg-card border border-border/80 snap-center transition-all duration-300 hover:shadow-xl">
                {}
                <div className="absolute inset-0 z-0 overflow-hidden">
                  <img src={card.image} data-wvc-srcset={card.srcset} data-wvc-sizes={card.sizes} alt={card.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/20 to-transparent" />
                </div>

                {}
                <div className="absolute top-4 right-4 z-10">
                  <Link to={card.link} aria-label={`Ver más sobre ${card.title}`} className="flex items-center justify-center size-9 rounded-full bg-background text-foreground shadow-sm transition-transform duration-300 group-hover:scale-110 group-hover:bg-destructive group-hover:text-destructive-foreground">
                    <ArrowUpRight className="size-4" />
                  </Link>
                </div>

                {}
                <div className="relative z-10 m-3 p-5 rounded-xl bg-background/95 backdrop-blur-sm shadow-sm border border-border/40 flex flex-col justify-between">
                  <div>
                    <h3 className="font-default text-base font-bold tracking-tight text-foreground line-clamp-2">
                      {card.title}
                    </h3>
                    <p className="mt-2 text-xs text-muted-foreground leading-relaxed line-clamp-3">
                      {card.description}
                    </p>
                  </div>

                  {}
                  <div className="mt-4 pt-1">
                    <Button asChild size="sm" className="rounded-full bg-foreground text-background hover:bg-foreground/90 text-2xs font-semibold px-3.5 py-1.5 h-auto uppercase tracking-wider transition-colors inline-flex items-center gap-1.5 shadow-xs">
                      <Link to={card.link}>
                        <span>MÁS INFORMACIÓN</span>
                        <div className="rounded-full bg-background/20 p-0.5">
                          <ArrowUpRight className="size-3 text-background" />
                        </div>
                      </Link>
                    </Button>
                  </div>
                </div>

                {}
                <div className="absolute bottom-0 inset-x-0 h-1 bg-destructive/90 transition-opacity duration-300 group-hover:opacity-100" />
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}